import { LocalAuthoritiesService } from './fetch-local-authorities/local-authorities.service';
import { PlotLocalAuthoritiesService } from './plot-local-authorities/plot-local-authorities.service';

export const services = [LocalAuthoritiesService, PlotLocalAuthoritiesService];

export * from './fetch-local-authorities/local-authorities.service';
export * from './plot-local-authorities/plot-local-authorities.service';
